import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestSupplierDetailsAction } from 'components/dashboard/actions';
import { Reports } from './index';

type ReportsProps = {
  pointOfSaleEnabled?: boolean;
  supplierId?: number | null;
};

const mapStateToProps = (state, ownProps: ReportsProps) => {
  const pointOfSaleEnabled = ownProps.pointOfSaleEnabled ?? state.dashboard.pointOfSaleEnabled;
  const canViewVatSaleReport =
    state.salesReport.reportContainer.isVatPayer && Boolean(pointOfSaleEnabled);
  const supplierId = ownProps.supplierId ?? state.dashboard.supplierId;
  return {
    canViewVatSaleReport,
    supplierId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ requestSupplierDetailsAction }, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const ReportsContainer = connector(Reports);

export { ReportsContainer as Reports };
